import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

init();

function init() {
  const popups = Array.from(document.querySelectorAll("[id^=popup]"));

  if (popups.length) {
    generatePopupStyles(popups);
    initOpenButtons();
    initCloseButtons();
    window.addEventListener(
      "load",
      () => (document.body.dataset.dialoginit = ""),
    );
  }
}

function generatePopupStyles(popups) {
  const styleTag = document.createElement("style");
  let popupStyles = popups.map((popup) => {
    popup.onclick = (event) => event.stopPropagation();

    const name = popup.id.replace("popup_", "");
    return `body[data-dialog="${name}"] #${popup.id}`;
  });
  popupStyles = popupStyles.join(",");
  popupStyles = `${popupStyles}{ visibility: visible; opacity: 1; transition: opacity 200ms; }`;
  styleTag.innerHTML = popupStyles;
  document.head.appendChild(styleTag);
}

function initOpenButtons() {
  const openButtons = Array.from(document.querySelectorAll("[data-popup]"));

  openButtons.forEach((openButton) => {
    openButton.addEventListener("click", (event) =>
      openPopup(event.currentTarget.dataset.popup),
    );
  });
}

export function openPopup(name) {
  const popup = document.getElementById(`popup_${name}`);
  if (popup && document.body.dataset.dialog !== name) {
    document.body.dataset.dialog = name;
    clearAllBodyScrollLocks();
    disableBodyScroll(popup);
  }
}

function initCloseButtons() {
  const closeButtons = Array.from(
    document.querySelectorAll("[data-popup-close]"),
  );

  closeButtons.forEach((closeButton) =>
    closeButton.addEventListener("click", closePopups),
  );

  document.getElementById("overlay").addEventListener("click", closePopups);

  document.addEventListener("keydown", ({ code }) => {
    if (code === "Escape") {
      closePopups();
    }
  });
}

function closePopups() {
  document.body.removeAttribute("data-dialog");
  clearAllBodyScrollLocks();
}
